import b64 from 'base64-js';
import { gunzipSync } from 'fflate';

export function decompressToBase64(base64String) {
    if (!base64String || base64String.length === 0)
    {
        return base64String;
    }
    const bytes = b64.toByteArray(base64String);
    const decompressed = gunzipSync(bytes);
    return b64.fromByteArray(decompressed);
}
export default decompressToBase64;

export var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

